/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerateStreamContainerLocal = {
    readonly accessToken: string | null;
    readonly " $refType": "ModerateStreamContainerLocal";
};
export type ModerateStreamContainerLocal$data = ModerateStreamContainerLocal;
export type ModerateStreamContainerLocal$key = {
    readonly " $data"?: ModerateStreamContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerateStreamContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerateStreamContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'db4ec936c52f2d4236496c5f1c701ca4';
export default node;
